import React from 'react';
import { Timer, AlertTriangle, Zap, MinusCircle } from 'lucide-react';
import { dashboardData } from './data';
export function BonusesDeductions() {
  const {
    bonuses,
    deductions
  } = dashboardData;
  return <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch" data-id="element-1">
      {/* Speed Bonus */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden h-full flex flex-col" data-id="element-2">
        <div className="px-6 py-5 border-b border-slate-200 flex items-center gap-3 bg-white" data-id="element-3">
          <div className="w-9 h-9 rounded-lg bg-green-50 text-green-600 flex items-center justify-center shrink-0" data-id="element-4">
            <Zap size={20} data-id="element-5" />
          </div>
          <div data-id="element-6">
            <h2 className="text-base font-bold text-[#0a1e5e] uppercase tracking-wide" data-id="element-7">
              Speed Bonus
            </h2>
            <p className="text-xs text-slate-500 mt-0.5" data-id="element-8">(Team)</p>
          </div>
        </div>

        <div className="p-6 flex-1 flex flex-col" data-id="element-9">
          <div className="space-y-3 mb-6" data-id="element-10">
            {bonuses.speedBonus.map((bonus, idx) => <div key={idx} className="flex justify-between items-center py-2 border-b border-slate-200 last:border-0" data-id="element-11">
                <span className="text-sm font-medium text-slate-600" data-id="element-12">
                  {bonus.condition}
                </span>
                <span className="text-sm font-bold text-green-600" data-id="element-13">
                  {bonus.points} POINTS
                </span>
              </div>)}
          </div>

          <div className="bg-green-50 border border-green-200 rounded-xl p-4 text-center mt-auto" data-id="element-14">
            <p className="text-3xl font-black text-green-600" data-id="element-15">
              +{bonuses.earnedThisMonth.toLocaleString()}
            </p>
            <p className="text-[10px] font-bold text-green-800 uppercase mt-1" data-id="element-16">
              Points Earned This Month
            </p>
          </div>
        </div>
      </div>

      {/* Deductions */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden h-full flex flex-col" data-id="element-17">
        <div className="px-6 py-5 border-b border-slate-200 flex items-center gap-3 bg-white" data-id="element-18">
          <div className="w-9 h-9 rounded-lg bg-red-50 text-red-600 flex items-center justify-center shrink-0" data-id="element-19">
            <MinusCircle size={20} data-id="element-20" />
          </div>
          <div data-id="element-21">
            <h2 className="text-base font-bold text-[#0a1e5e] uppercase tracking-wide" data-id="element-22">
              Deductions
            </h2>
            <p className="text-xs text-slate-500 mt-0.5" data-id="element-23">(Team)</p>
          </div>
        </div>

        <div className="p-6 flex-1" data-id="element-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 h-full" data-id="element-25">
            <div className="bg-slate-50 rounded-xl p-4 border border-slate-200" data-id="element-26">
              <div className="flex items-center gap-2 mb-3" data-id="element-27">
                <Timer size={16} className="text-slate-500" data-id="element-28" />
                <h3 className="text-xs font-bold text-slate-700 uppercase" data-id="element-29">
                  Non PTO Hours
                </h3>
              </div>
              <p className="text-[10px] text-slate-500 mb-3" data-id="element-30">
                For time missed that is not PTO. We round down to the nearest
                hour.
              </p>
              <div className="space-y-2" data-id="element-31">
                <div className="flex justify-between items-center" data-id="element-32">
                  <span className="text-xs text-slate-600" data-id="element-33">Up to 15 hours</span>
                  <span className="text-sm font-bold text-red-600" data-id="element-34">
                    {deductions.nonPto.upTo15}{' '}
                    <span className="text-[10px] text-slate-500" data-id="element-35">PTS/HR</span>
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-36">
                  <span className="text-xs text-slate-600" data-id="element-37">Over 15 hours</span>
                  <span className="text-sm font-bold text-red-600" data-id="element-38">
                    {deductions.nonPto.over15}{' '}
                    <span className="text-[10px] text-slate-500" data-id="element-39">PTS/HR</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-red-50 rounded-xl p-4 border border-red-200 flex flex-col justify-center" data-id="element-40">
              <div className="flex items-center gap-2 mb-3" data-id="element-41">
                <AlertTriangle size={16} className="text-red-600" data-id="element-42" />
                <h3 className="text-xs font-bold text-red-700 uppercase" data-id="element-43">
                  File Not Moving
                </h3>
              </div>
              <p className="text-2xl font-black text-red-600 mb-1" data-id="element-44">
                -{deductions.fileNotMoving}{' '}
                <span className="text-sm text-slate-600" data-id="element-45">PTS/DAY</span>
              </p>
              <p className="text-[10px] text-red-700" data-id="element-46">
                for each file in "Not Moving" status
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}